import { useTranslation } from 'react-i18next';
import { useNav } from '../../store/nav';
import { haptic } from '../../hooks/useTelegram';
import { FigIcon, type FigIconName } from '../FigIcon';

/** The four primary actions under the balance card (Figma: Receive/Send/Buy/QR). */
export function ActionRow() {
  const { t } = useTranslation();
  const push = useNav((s) => s.push);

  const actions: { key: string; icon: FigIconName; label: string; onClick: () => void }[] = [
    { key: 'receive', icon: 'receive', label: t('wallet.receive'), onClick: () => push({ name: 'receive' }) },
    { key: 'send', icon: 'send', label: t('wallet.send'), onClick: () => push({ name: 'send' }) },
    { key: 'buy', icon: 'buy', label: t('wallet.buy'), onClick: () => push({ name: 'buy' }) },
    { key: 'qr', icon: 'qr', label: t('wallet.qr'), onClick: () => push({ name: 'qr' }) },
  ];

  return (
    <div className="flex gap-3">
      {actions.map(({ key, icon, label, onClick }) => (
        <button
          key={key}
          onClick={() => {
            haptic();
            onClick();
          }}
          className="flex flex-1 flex-col items-center gap-2 rounded-[18px] bg-card py-3 shadow-card transition-transform active:scale-95"
        >
          <FigIcon name={icon} size={26} className="text-accent" />
          <span className="text-[12px] font-medium text-ink">{label}</span>
        </button>
      ))}
    </div>
  );
}
